<script>
    import { scrollToAchor } from '@/helpers'

    export let withoutScroll = false

    const handleClick = () => {
        if (!withoutScroll){
            scrollToAchor('contacts')
            ym(88256496,'reachGoal','demo_click');
        }
    }
</script>

<button on:click={handleClick}>Заказать демо</button>